import styled from 'styled-components';
import Colors from '../../../constants/colors';
import { IconModal } from '../../../styles/icon';

const Icon = styled(IconModal)``;

const CloseText = styled.p`
  display: none;
  cursor: pointer;
  border: none;
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.shade01};
  margin: 0 4px;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  padding: 8px;
  width: 48px;
  height: 48px;
  background: ${Colors.shade08};
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 40px;
  cursor: pointer;
  border: none;
  
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  right: 45px;
  background: ${Colors.shade08};
  transition: 0.4s;

  &:hover {
    width: auto;
    background-color: ${Colors.shade07};
    
    ${Icon} {
      display: flex;
      margin-left: 0;
    }
    
    ${CloseText} {
      display: flex;
      margin-left: 15px;
    }
  }
`;

const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  CloseButton, CloseText, IconContainer, Icon,
};
